"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _atoms = require("../../atoms");

var _Table = _interopRequireDefault(require("./organisms/Table"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var standardSpacing = 2;
var doubleSpacing = 2 * standardSpacing;

var Body = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "DemoSettingsForm__Body"
})(["padding:", ";"], function (_ref) {
  var spacing = _ref.theme.spacing;
  return "".concat(spacing(standardSpacing), " ").concat(spacing(doubleSpacing));
});

var Footer = /*#__PURE__*/(0, _styledComponents["default"])(_core.Grid).withConfig({
  displayName: "DemoSettingsForm__Footer"
})(["", ""], function (_ref2) {
  var _ref2$theme = _ref2.theme,
      palette = _ref2$theme.palette,
      spacing = _ref2$theme.spacing;
  return "\n    background-color: ".concat(palette.grey[50], ";\n    padding: ").concat(spacing(standardSpacing), ";\n  ");
});

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "DemoSettingsForm__Container"
})(["", ""], function (_ref3) {
  var palette = _ref3.theme.palette;
  return "\n    background-color: ".concat(palette.background.paper, ";\n  ");
});

var DemoSettingsForm = function DemoSettingsForm(_ref4) {
  var demoVersions = _ref4.demoVersions,
      tableTitle = _ref4.tableTitle,
      onGenerateNewDemoVersion = _ref4.onGenerateNewDemoVersion,
      onActivateDemoVersion = _ref4.onActivateDemoVersion,
      disableGenerateNewDemoVersionButton = _ref4.disableGenerateNewDemoVersionButton,
      props = _objectWithoutProperties(_ref4, ["demoVersions", "tableTitle", "onGenerateNewDemoVersion", "onActivateDemoVersion", "disableGenerateNewDemoVersionButton"]);

  var demoVersionsTableColumns = [{
    id: 'isActive',
    label: 'Active',
    minWidth: 50
  }, {
    id: 'version',
    label: 'Version',
    minWidth: 170
  }];
  return _react["default"].createElement(Container, props, _react["default"].createElement(Body, null, _react["default"].createElement(_core.Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "stretch",
    spacing: 2
  }, _react["default"].createElement(_Table["default"], {
    title: tableTitle,
    rows: demoVersions,
    columns: demoVersionsTableColumns,
    showPagination: true,
    onActivateDemoVersion: onActivateDemoVersion
  }))), _react["default"].createElement(Footer, {
    container: true,
    direction: "row",
    justify: "flex-end",
    alignItems: "center"
  }, _react["default"].createElement(_core.Grid, {
    item: true
  }, _react["default"].createElement(_atoms.Button, {
    onClick: onGenerateNewDemoVersion,
    size: "small",
    disabled: disableGenerateNewDemoVersionButton,
    startIcon: _react["default"].createElement(_atoms.Icon, {
      icon: "plus",
      size: "small",
      color: "inherit"
    })
  }, "Generate New Demo Version"))));
};

DemoSettingsForm.propTypes = {
  demoVersions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    version: _propTypes["default"].number.isRequired,
    isActive: _propTypes["default"].bool.isRequired,
    id: _propTypes["default"].string
  })),
  tableTitle: _propTypes["default"].string.isRequired,
  onGenerateNewDemoVersion: _propTypes["default"].func.isRequired,
  onActivateDemoVersion: _propTypes["default"].func.isRequired,
  disableGenerateNewDemoVersionButton: _propTypes["default"].bool
};
var _default = DemoSettingsForm;
exports["default"] = _default;